module.exports = __webpack_public_path__ + "static/media/17UN-Women7.e60950d8.jpg";